import { inject } from '@angular/core';
import { TaApiService, CourseLevelApiService } from '@shared/services';
import { FormConfig } from '../edit-create-form.interfaces';
import { TA_SELECT_CONFIG, TA_TASK_TYPE_SELECT_CONFIG, TRAINING_STATUS_SELECT_CONFIG, COURSE_LEVEL_SELECT_CONFIG } from '@shared/components/generic-select/generic-select.configs';

export const taTrainingFormPopoverConfig = (): FormConfig => {
  const taApiService = inject(TaApiService);
  const courseLevelApiService = inject(CourseLevelApiService);

  return {
    fields: [
      {
        key: 'id', label: 'ID', type: 'text', width: 'full', hidden: true
      },
      {
        key: 'taId', label: 'Trợ giảng', required: true, width: 'full',
        type: 'select', config: { ...TA_SELECT_CONFIG, service: taApiService },
        disabled: true
      },
      {
        key: 'type', label: 'Loại nhiệm vụ', required: true, width: '1/3',
        type: 'select', config: { ...TA_TASK_TYPE_SELECT_CONFIG },
        disabled: true
      },
      {
        key: 'courseLevelId', label: 'Cấp độ', required: false, width: '1/3',
        type: 'select',
        config: { ...COURSE_LEVEL_SELECT_CONFIG, service: courseLevelApiService },
        dependsOn: 'type',
        disabled: true
      },
      {
        key: 'status', label: 'Trạng thái', required: true, width: '1/3',
        type: 'select', config: { ...TRAINING_STATUS_SELECT_CONFIG }
      },
      {
        key: 'trainerId', label: 'Trainer', required: false, width: '2/3',
        type: 'select', config: { ...TA_SELECT_CONFIG, service: taApiService }
      },
      {
        key: 'deadline', label: 'Hạn chót', required: false, width: '1/3',
        type: 'datepicker', placeholder: 'Chọn hạn chót'
      },
      {
        key: 'note', label: 'Ghi chú', required: false, width: 'full',
        type: 'textarea', placeholder: 'Nhập ghi chú'
      }
    ]
  };
};
